<template>
  <div class="box">
    <vue-drawer-layout :drawer-width="280" ref="drawerLayout" @mask-click="closeMenu" @slide-end="handleSlideEnd">
      <div class="drawer" slot="drawer">
        <div class="header-box">
          <div class="cancel-popup" @click="closeMenu">
            <svg-icon class="hooked-close" icon-file-name="close"></svg-icon>
          </div>

          <svg-icon class="hooked-menu" icon-file-name="logo"></svg-icon>
        </div>
        <div @click="closeMenu()" class="Home">
          <a href="#01"><svg-icon class="home-icon" icon-file-name="home"></svg-icon><span>Home</span></a>
        </div>
        <div class="menu-child-box">
          <div class="menu-head">
            <a href="#02" @click="closeMenu()">
              <svg-icon class="Technica-Service-icon" icon-file-name="Technica-Service"></svg-icon>
              Technical & Service
            </a>
          </div>
          <div class="child">
            <p v-for="(item, index) in techNavData" :key="index" @click="toTechDetails(index)">{{ item }}</p>
          </div>
        </div>
        <div class="Home">
          <a href="#03" @click="closeMenu()"><svg-icon class="home-icon" icon-file-name="about"></svg-icon>About</a>
        </div>
        <div class="menu-child-box">
          <div class="menu-head">
            <a href="#04" @click="closeMenu()">
              <svg-icon class="Technica-Service-icon" icon-file-name="join-us"></svg-icon>
              Join Us
            </a>
          </div>
          <div class="child">
            <p v-for="(item, index) in joinUsNavData" :key="index" @click="toJoinUsDetail(index)">{{ item }}</p>
          </div>
        </div>
        <div class="Home">
          <a href="#05" @click="closeMenu()">
            <svg-icon class="home-icon" icon-file-name="Contact"></svg-icon>
            Contact
          </a>
        </div>
      </div>
    </vue-drawer-layout>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    scrollY: Number,
  },
  data() {
    return {
      techNavData: [
        'Blockchain consulting',
        'Blockchain architecture design',
        'Smart contract development',
        'Blockchain application development',
        'Digital asset management',
        'Maintenance and support',
      ],
      joinUsNavData: [
        'Senior Contract Development Engineer',
        'Blockchain Product Manager',
        'Original Art Designer',
        'Marketing Operations Specialist',
      ],
    };
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.$refs.drawerLayout.toggle();
        let addTop = document.getElementsByClassName('drawer-wrap')[0];
        addTop.style.top = scrollY + 'px';
      }
    },
  },
  methods: {
    handleSlideEnd(blo) {
      this.$emit('closeMe', blo);
    },
    closeMenu() {
      this.$refs.drawerLayout.toggle(false);
    },
    toTechDetails(num) {
      this.$store.commit('setTechTabIndex', num);
      this.$router.push({ name: 'TechDetails', query: { titleId: String(num) } });
    },
    toJoinUsDetail(num) {
      this.closeMenu();
      this.$store.commit('setJoinIndex', num);
      this.$router.push({ name: 'JoinUsDetail', query: { titleId: String(num) } });
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.box {
  .drawer {
    width: 100%;
    height: 100%;
    background: #141414;
    .header-box {
      position: relative;
      height: 0.45rem;
      .cancel-popup {
        position: relative;
        width: 50px;
        height: 0.45rem;
        .hooked-close {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 10px;
          width: 15px;
          height: 15px;
        }
      }
      .hooked-menu {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 70%;
        height: 60px;
      }
    }
    .Home {
      height: 42px;
      border-top: 1px solid #5a5a5a;
      font-family: Verdana, Geneva, sans-serif;
      font-size: 13px;
      line-height: 42px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 600;
      display: flex;
      align-items: center;
      a {
        display: flex;
        align-items: center;
        width: 100%;
        color: #fff;
      }
      .home-icon {
        padding-left: 10px;
        width: 12px;
        height: 11px;
        margin-right: 10px;
      }
    }
    .menu-child-box {
      border-top: 1px solid #5a5a5a;
      padding-top: 13px;
      font-family: Verdana, Geneva, sans-serif;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 600;
      a {
        display: flex;
        align-items: center;
        flex: 1;
        color: #fff;
      }
      .Technica-Service-icon {
        padding-left: 10px;
        width: 12px;
        height: 11px;
        margin-right: 10px;
      }
      .child {
        padding-top: 2px;
        padding-bottom: 12px;
        p {
          padding-top: 14px;
          padding-left: 32px;
          opacity: 0.6;
          font-family: Verdana, Geneva, sans-serif;
          font-size: 12px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 400;
        }
      }
    }
  }
}
</style>

<style scoped>
.drawer-mask {
  background-color: transparent !important;
}
</style>
